// Simple event emitter for cross-component communication
class EventEmitter {
  constructor() {
    this.events = {};
  }

  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  off(event, callback) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(cb => cb !== callback);
  }

  emit(event, data) {
    if (!this.events[event]) return;
    this.events[event].forEach(callback => callback(data));
  }
}

// Create a singleton instance for global use
const eventEmitter = new EventEmitter();

// Define event types
export const EVENTS = {
  RESOURCE_UPDATED: 'resource_updated',
  RESOURCE_CREATED: 'resource_created',
  RESOURCE_DELETED: 'resource_deleted',
  PROJECT_DELETED: 'project_deleted'
};

export default eventEmitter;
